import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import MKBox from "components/MKBox";
import MKPagination from "components/MKPagination";
import DefaultNavbar from "hanyeleo/Navbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import EventCard from "pages/Home/sections/EventCard";
import Testimonials from "pages/Home/sections/Testimonials";
import EventList from "pages/Home/sections/EventList";
import getNavRoutes from "../navroutes";
import footerRoutes from "footer.routes";
import Axios from "utils/Axios";
import product5 from "assets/images/HanyeIcon.png";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCity } from "../redux/slices/city/citySlice";
import MKInput from "components/MKInput";
import { Autocomplete, TextField } from "@mui/material";
import bgPattern from "assets/images/shapes/pattern-lines.svg";
import MKTypography from "components/MKTypography";

const itemsPerPage = 10;

function Home() {
  const dispatch = useDispatch();
  const { location } = useParams();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [cities, setCities] = useState([]);
  const [slctdCity, setSlctdCity] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const selectedCity = useSelector((state) => state.city);
  const navigate = useNavigate();
  const [topEvents, setTopEvents] = useState([]);
  const [navRoutes, setNavRoutes] = useState([]);
  const [promoters, setPromoters] = useState([]);
  const [selectedPromoters, setSlctdPromoter] = useState("");
  const [venues, setVenues] = useState([]);
  const [selectedVenues, setSelectedVenues] = useState("");
  const [loading, setLoading] = useState(false);
  const [sampleImages, setSampleImages] = useState([]);
  const token = localStorage.getItem("token");

  //array of sample images for the gallery section
  const galleryItems = [
    { id: 1, imageUrl: "http://localhost/hanyeLeo/public/uploads/gallery/img_500_1725988835.8382.jpg", title: "Event 1" },
    { id: 2, imageUrl: "http://localhost/hanyeLeo/public/uploads/gallery/img_500_1725988835.8382.jpg", title: "Event 2" },
    { id: 3, imageUrl: "http://localhost/hanyeLeo/public/uploads/gallery/img_500_1725988835.8382.jpg", title: "Event 3" },
    { id: 4, imageUrl: "http://localhost/hanyeLeo/public/uploads/gallery/img_500_1725988835.8382.jpg", title: "Event 4" },
  ];

  const fetchEvents = async (page = 1, city = "") => {
    setLoading(true);
    const cityParam = city ? `&city=${city}` : "";
    const promotersParam =
      selectedPromoters !== "" ? `&promoters=${selectedPromoters}` : "";
    const venuesParam = selectedVenues !== "" ? `&venues=${selectedVenues}` : "";
    Axios.get(`?type=event&event_time=future&page=${page}${cityParam}${promotersParam}${venuesParam}`)
      .then((response) => {
        const allData = response.data.data;
        const pagination = response.data.pagination;
        setData(allData);
        setTotalPages(pagination.totalPages);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch events data", error);
        setLoading(false);
      });
  };

  const fetchPromoters = (venue = "") => {
    const venuesParam = venue !== "" ? `&venues=${venue}` : "";
    Axios.get(`?type=promoterActiveEvents${venuesParam}`)
      .then((response) => {
        setPromoters(response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch promoters", error);
      });
  };

  const setSelectedPromoter = (promoter) => {
    if (!promoter) { 
      setSlctdPromoter("")
      fetchVenues("");
      return;
    }
    setSlctdPromoter(promoter.value)
    fetchVenues(promoter.value);
  };

  const setSelectedVenue = (venue) => {
    if (!venue) {
      setSelectedVenues("");
      fetchPromoters("");
      return;
    }
    setSelectedVenues(venue.name);
    fetchPromoters(venue.name);
  };

  const fetchVenues = (promoter = "") => {
    const promotersParam =
      promoter !== "" ? `&promoters=${promoter}` : "";
    Axios.get(`?type=venues${promotersParam}`)
      .then((response) => {
        setVenues(response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch venues", error);
      });
  };

  const fetchTopEvents = async (city = "") => {
    const cityParam = city ? `&city=${city}` : "";
    Axios.get(`?type=top_events${cityParam}`)
      .then((response) => {
        const allData = response.data;
        setTopEvents(allData);
      })
      .catch((error) => {
        console.error("Failed to fetch top events data", error);
      });
  };

  const fetchCities = async () => {
    await Axios.get("?type=cities")
      .then((response) => {
        const citiesData = response.data;
        setCities(response.data);
        if (location) {
          const city = citiesData.find(
            (city) => city.title.toLowerCase() === `${location}`.toLowerCase()
          );

          if (!city) {
            dispatch(setCity({ title: "East Africa", id: "" }));
            navigate("/");
            return;
          } else {
            setSlctdCity(city.id);
            dispatch(setCity({ id: city.id, title: city.title }));
            navigate("/" + city.title.toLowerCase());
          }
        }
      })
      .catch((error) => {
        console.error("Failed to fetch countries:", error);
      });
  };

  const handleSelectCity = (cityId) => {
    setSlctdCity(cityId)
    if (!cityId) {
      dispatch(setCity({ title: "East Africa", id: "" }));
      navigate("/");
      return;
    }
    const selectedCity = cities.find((city) => city.id === cityId);
    if (selectedCity) {
      dispatch(setCity({ id: selectedCity.id, title: selectedCity.title }));
      navigate("/" + selectedCity.title.toLowerCase());
    }
  };

  const galleryImageUrl = (image) => {
    const parts = image.split('_');
    if (parts.length >= 3) {
      parts.splice(3, 0, 'img_250');
      image = parts.join('_');
    }
    return `${process.env.REACT_APP_BASE_IMAGE_URL}gallery/${image}`;
  };

  const getSampleImages = async () => {
    try {
      const res = await Axios.get("?type=recentMedia&limit=4");
      const imagesData = res.data || [];
      const images = imagesData
        .filter((i) => i && i.title)
        .map((i) => galleryImageUrl(i.title, "500"));
      setSampleImages(images.slice(0, 4));
    } catch (error) {
      console.error("Error fetching sample images:", error);
    }
  };

  useEffect(() => {
    setNavRoutes(getNavRoutes());
    fetchCities();
    fetchTopEvents(selectedCity.id);
    fetchPromoters();
    fetchVenues();
    getSampleImages();
  }, []);

  useEffect(() => {
    setPage(1);
    fetchEvents(1, selectedCity.id);
  }, [selectedVenues, selectedPromoters, selectedCity])

  useEffect(() => {
    fetchEvents(page, selectedCity.id);
  }, [page]);

  const SignIn = () => {
    navigate("/sign-in/");
  };

  const EventGalleries = () => {
    navigate("/galleries");
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <div className="min-h-screen">
      <DefaultNavbar routes={navRoutes} relative center />

      {/* Enhanced Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900">
        {/* Animated Background Elements */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-72 h-72 bg-white rounded-full mix-blend-multiply filter blur-3xl animate-pulse"></div>
          <div className="absolute top-40 right-20 w-72 h-72 bg-purple-300 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-700"></div>
          <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-pink-300 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-1000"></div>
        </div>

        <Container className="relative z-10">
          <div className="flex flex-col-reverse md:flex-row items-center justify-between py-16 md:py-24 md:space-x-16 px-6">
            <div className="w-full md:w-1/2 text-center md:text-left mb-8 md:mb-0">
              <div className="inline-block mb-4 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white text-sm font-semibold">
                Your Gateway to Unforgettable Experiences
              </div>
              
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white mb-6 leading-tight">
                Great Events Start at{" "}
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 via-pink-300 to-purple-300">
                  HanyeLeo
                </span>
              </h1>
              
              <p className="text-gray-200 text-lg md:text-xl mb-4 leading-relaxed">
                Welcome to HanyeLeo, bringing you the hottest events and parties across East Africa!
              </p>
              
              <p className="text-gray-300 text-base md:text-lg mb-8 leading-relaxed">
                Browse our event pages to see what's going on, and come back to view our image
                galleries of previous events.
              </p>

              <div className="md:w-3/4 w-full mb-6">
                <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-1">
                  <MKInput
                    select
                    label=""
                    value={slctdCity}
                    onChange={(e) => {
                      handleSelectCity(e.target.value);
                    }}
                    fullWidth
                    SelectProps={{ native: true }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        backgroundColor: 'white',
                        '& fieldset': { border: 'none' },
                      },
                    }}
                  >
                    <option value="">East Africa</option>
                    {cities?.map((city) => (
                      <option key={city.id} value={city.id}>
                        {city.title}
                      </option>
                    ))}
                  </MKInput>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  type="button"
                  onClick={SignIn}
                  className="group relative px-8 py-4 bg-gradient-to-r from-yellow-400 to-pink-500 text-white font-bold rounded-xl shadow-2xl hover:shadow-pink-500/50 transform hover:scale-105 transition-all duration-300 overflow-hidden"
                >
                  <span className="relative z-10">Get Started </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-pink-500 to-yellow-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </button>
                
                <button
                  type="button"
                  onClick={EventGalleries}
                  className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-bold rounded-xl border-2 border-white/30 hover:bg-white/20 hover:border-white/50 transform hover:scale-105 transition-all duration-300 shadow-lg"
                >
                  Event Galleries 
                </button>
              </div>
            </div>

            <div className="w-full md:w-1/2 flex items-center md:justify-end mb-8 md:mb-0">
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-500 rounded-full blur-2xl opacity-30 animate-pulse"></div>
                <img 
                  src={product5} 
                  alt="Landing Image" 
                  className="relative z-10 drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" 
                />
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* Enhanced Gallery Section */}
      <div position="relative" className="bg-gradient-to-br from-gray-50 via-purple-50 to-gray-100 py-16">
        <Container>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-pink-600 mb-4">
              Recent Moments
            </h2>
            <p className="text-gray-600 text-lg">
              Captured memories from our latest events
            </p>
          </div>

          <Grid container justifyContent="center">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-x-10 w-full">
              {sampleImages.length > 0 ? (
                sampleImages.map((item, idx) => (
                  <div 
                    key={item} 
                    className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
                  >
                    <img 
                      src={item} 
                      alt={`Recent ${idx + 1}`} 
                      className="h-auto w-full object-cover rounded-2xl group-hover:scale-110 transition-transform duration-700" 
                    />
                    <div onClick={EventGalleries} className="absolute inset-0 bg-gradient-to-t from-purple-900/80 via-purple-900/20 to-transparent cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl flex items-end justify-center pb-6">
                      <span className="text-white font-bold text-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                        View Gallery
                      </span>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-span-full flex items-center justify-center py-12">
                  <div className="text-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-purple-600 mx-auto mb-4"></div>
                    <p className="text-gray-500 text-lg">Loading amazing moments...</p>
                  </div>
                </div>
              )}
            </div>
          </Grid>
        </Container>
      </div>

      {/* Top Events Section */}
      <Container sx={{ mt: 8 }} bgColor="white" className="pb-8">
        <div className="text-center mb-12 bg-white">
          <h2 className="text-3xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-pink-600 mb-4">
            Top Events
          </h2>
          <p className="text-gray-600 text-lg">
            Don't miss out on these incredible experiences
          </p>
        </div>
        <Grid container spacing={3}>
          {topEvents?.map((event) => (
            <EventCard key={event.title} {...event} />
          ))}
        </Grid>
      </Container>

      {/* Filters Section */}
      <Container>
        <div className="bg-white  p-8 mb-8">
          <div className="text-center mb-6">
            <h3 className="text-2xl font-bold text-gray-800 mb-2">Find Your Perfect Event</h3>
            <p className="text-gray-600">Filter by promoter or venue</p>
          </div>
          
          <div className="flex md:flex-row flex-col gap-6 justify-center items-center">
            <div className="lg:w-1/3 w-full">
              <Autocomplete
                disablePortal
                id="promoter-autocomplete"
                options={promoters}
                getOptionLabel={(option) => option.promoter}
                onChange={(event, value) => {
                  setSelectedPromoter(value);
                }}
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    label="🎭 Select Promoter" 
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                      },
                    }}
                  />
                )}
              />
            </div>
            <div className="lg:w-1/3 w-full">
              <Autocomplete
                disablePortal
                id="venue-autocomplete"
                options={venues}
                getOptionLabel={(option) => option?.name}
                onChange={(event, value) => {
                  setSelectedVenue(value);
                }}
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    label="📍 Select Venue" 
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                      },
                    }}
                  />
                )}
              />
            </div>
          </div>
        </div>
      </Container>

      <EventList events={data} selectedLocation={selectedCity} loading={loading} />

      {/* Pagination */}
      <Container sx={{ mt: 5 }}>
        <MKPagination count={totalPages} page={page} onChange={handlePageChange}>
          <MKPagination item disabled={page === 1} onClick={() => handlePageChange(null, page - 1)}>
            <Icon>keyboard_arrow_left</Icon>
          </MKPagination>
          {[...Array(totalPages).keys()].map((pageNumber) => (
            <MKPagination
              item
              key={pageNumber + 1}
              onClick={() => handlePageChange(null, pageNumber + 1)}
              active={page === pageNumber + 1}
            >
              {pageNumber + 1}
            </MKPagination>
          ))}
          <MKPagination item disabled={page === totalPages} onClick={() => handlePageChange(null, page + 1)}>
            <Icon>keyboard_arrow_right</Icon>
          </MKPagination>
        </MKPagination>
      </Container>

      <Testimonials />

      <DefaultFooter content={footerRoutes} />
    </div>
  );
}

export default Home;